// extracted by mini-css-extract-plugin
export default {"protectedAppOutletContainer":"ProtectedAppOutlet_protectedAppOutletContainer__MxP2m","protectedAppOutletWrapper":"ProtectedAppOutlet_protectedAppOutletWrapper__9NEVr"};